import { render, staticRenderFns } from "./inboundreport_main.vue?vue&type=template&id=20d58de8&scoped=true"
import script from "./inboundreport_main.vue?vue&type=script&lang=js"
export * from "./inboundreport_main.vue?vue&type=script&lang=js"
import style0 from "./inboundreport_main.vue?vue&type=style&index=0&id=20d58de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d58de8",
  null
  
)

export default component.exports